import {Service} from '../../utils/Service';

export default{
      querySystemPermssionByRoleType6(data) {  //获取授权权限
            return Service({
              url: 'operationApi/systemPermssionapi/querySystemPermssionByRoleType',
              data,
              method: 'POST' ,
            })
      },

      queryBusUserPermMapByShopUserGuid(data) {  //获取授权列表
          return Service({
            url: 'operationApi/busUserPermMapApi/queryBusUserPermMapByShopUserGuid',
            data,
            method: 'POST'
          })
      },
      addBusUserPermMapList(data) {  //批量添加权限
        return Service({
          url: 'operationApi/busUserPermMapApi/addBusUserPermMapList',
          data,
          method: 'POST'
        })
      },
      querySystemPermssionByParentIdNavigation(data) {  //用户左侧菜单
        return Service({
          url: 'operationApi/systemPermssionapi/querySystemPermssionByParentIdNavigation',
          data,
          method: 'POST'
        })
      },
      querySystemPermssionByRoleType7(data) {  //获取员工授权权限
        // console.log(data)
        return Service({
          url: 'operationApi/systemPermssionapi/querySystemPermssionByRoleType7',
          data,
          method: 'POST' ,
        })
  },
}



// WEBPACK FOOTER //
// ./src/api/authority/authority.js